// Dependencies
import Vue from 'vue';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';
import Vuex from 'vuex';
import App from './App.vue';
import router from '@/router';
import VueI18n from 'vue-i18n';
import VueCookies from 'vue-cookies';
import VueShepherd from 'vue-shepherd';
import vuetify from './plugins/vuetify';
import Notifications from 'vue-notification';
import VueLocalStorage from 'vue-localstorage';
// CSS
import '@/css/index.css';
import "shepherd.js/dist/css/shepherd.css";
import '@mdi/font/css/materialdesignicons.css'
// Possibly not needed
import '@progress/kendo-theme-default/dist/all.css';
import 'vue-search-select/dist/VueSearchSelect.css'
import messages from './lang';
import VueTailwind from 'vue-tailwind'
import ZoomOnHover from "vue-zoom-on-hover";
import { Grid } from '@progress/kendo-vue-grid';
import VueCountdown from '@chenfengyuan/vue-countdown';
import { TModal, TRadio } from 'vue-tailwind/dist/components'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// Common components
import Row from "@/components/common/Row.vue";
import Card from "@/components/common/Card.vue";
import Btn from "@/components/common/Button.vue";
import Modal from "@/components/common/Dialog.vue";
import CrudTable from "@/components/common/CrudTable.vue";
import DataTable from "@/components/common/DataTable.vue";
import LoadingBar from "@/components/common/LoadingBar.vue";
import ExamImg from "@/components/common/ExamImg.vue";
import ExamQuestionResult from "@/components/ExamQuestionResult.vue";

import { record } from 'rrweb'; 

const settings = {
    't-modal': {
        component: TModal,
        props: {
            fixedClasses: {
                overlay: 'z-40  overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-opacity-50',
                wrapper: 'relative mx-auto z-50 max-w-lg px-3 py-12',
                modal: 'overflow-visible relative  rounded',
                body: 'p-3',
                header: 'border-b p-3 rounded-t',
                footer: ' p-3 rounded-b',
                close: 'flex items-center justify-center rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50'
            },
            classes: {
                overlay: 'bg-black',
                wrapper: '',
                modal: 'bg-white shadow',
                body: 'p-3',
                header: 'border-gray-100',
                footer: 'bg-gray-100',
                close: 'bg-gray-100 text-gray-600 hover:bg-gray-200',
                closeIcon: 'fill-current h-4 w-4',
                overlayEnterClass: 'opacity-0',
                overlayEnterActiveClass: 'transition ease-out duration-100',
                overlayEnterToClass: 'opacity-100',
                overlayLeaveClass: 'opacity-100',
                overlayLeaveActiveClass: 'transition ease-in duration-75',
                overlayLeaveToClass: 'opacity-0',
                enterClass: '',
                enterActiveClass: '',
                enterToClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: ''
            },
            variants: {
                danger: {
                    overlay: 'bg-red-100',
                    header: 'border-red-50 text-red-700',
                    close: 'bg-red-50 text-red-700 hover:bg-red-200 border-red-100 border',
                    modal: 'bg-white border border-red-100 shadow-lg',
                    footer: 'bg-red-50'
                }
            }
        }
    },
    't-radio': {
        component: TRadio,
        props: {
            wrapped: true,
            classes: {
                label: 'text-sm uppercase mx-2 text-gray-700',
                input: 'text-blue-500 transition duration-100 ease-in-out border-gray-300 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out',
                inputWrapper: 'inline-flex',
                wrapper: 'flex items-center',
            }

        }
    },
}

Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(VueCookies);
Vue.use(ZoomOnHover);
Vue.use(VueShepherd);
Vue.use(Notifications);
Vue.use(VueLocalStorage);
// TODO: Remove Tailwind
Vue.use(VueTailwind, settings);
Vue.use(VuetifyDialog, {
    context: {
      vuetify
    }
  });
Vue.config.productionTip = false;

Vue.component('Grid', Grid);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component(VueCountdown.name, VueCountdown);
Vue.component(Btn.name, Btn);
Vue.component(Modal.name, Modal);
Vue.component(Card.name, Card);
Vue.component(ExamImg.name, ExamImg);
Vue.component(ExamQuestionResult.name, ExamQuestionResult);
Vue.component(CrudTable.name, CrudTable);
Vue.component(DataTable.name, DataTable);
Vue.component(LoadingBar.name, LoadingBar);
Vue.component(Row.name, Row);

Vue.prototype.$confirmDialog = function (options) {
    return Vue.prototype.$dialog.confirm({
      title: options.title || i18n.t('confirmation'),
      text: options.text || i18n.t('areYouSure'),
      actions: {
        false: i18n.t('cancel'),
        true: {
          text: i18n.t('confirm'),
          color: 'primary'
        }
      },
      persistent: true,
      ...options // Override any other options if needed
    });
  };

Vue.config.performance = true

export const i18n = new VueI18n({
    locale: 'ro',
    fallbackLocale: 'en',
    messages
})

export const store = new Vuex.Store({
    state: {
        params: {}, 
        discipline: {},
        examGroupId:undefined,
        stopFn: null, // To hold the stop function
        events: [], // To store the recorded events
    },
    mutations: {
        SET_PARAMS(state, params) {
            state.params = params
        },
        SET_DISCIPLINE(state, discipline) {
            state.discipline = discipline
        },
        startRecording(state) {
            state.events = [];
            state.stopFn = record(                
                {
                emit: (event) => {
                    // Record only click events
                    let validEvent = true;
                    // if(event.data.texts ){
                    //     if(event.data.texts.length ==1){
                    //         //console.log("event.data.texts[0]",event.data.texts[0]);       
                    //         if(event.data.texts[0].value &&  (
                    //             event.data.texts[0].value.includes("Timp până la")
                    //             || event.data.texts[0].value.includes("Time until")
                    //         )){
                    //             validEvent=false;
                    //         }
                    //     }
                    // }
                    //console.log("event",validEvent,event);
                    if(validEvent){
                        state.events.push(event); // Save events
                    }
                    
                },
                // To ensure other events are ignored, use this option
                maskAllInputs: true,  // Optionally mask inputs if needed
                recordCanvas: false,  // Optional: disable canvas recording (if not needed)
            });
            console.log("Recording started");
        },
        stopRecording(state) {
            if (state.stopFn) {
                state.stopFn(); // Stop recording
                state.stopFn = null;
                console.log("Recording stopped. Recorded events:", state.events);
            }
        },
        setExamGroupId(state, examGroupId) {
            state.examGroupId = examGroupId;
        },
    },
    actions: {
        startRecording({ commit }) {
            commit("startRecording");
        },
        stopRecording({ commit }) {
            commit("stopRecording");
        }
    }
})

export default new Vue({
    router,
    i18n,
    vuetify,
    store,
    render: function (h) { return h(App) }
}).$mount('#app')
